// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__HvFFa","errorLogs":"EditorFooter_errorLogs__121oO"};